import { teal, deepOrange } from '@material-ui/core/colors';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: deepOrange,
        secondary: teal,
    },
    typography: {
        fontFamily: 'Abel',
        h2: {
            fontWeight: 300,
            letterSpacing: '2px',
        },
    },
});

export default responsiveFontSizes(theme);
